import React from "react";
import { Card, CardContent, CardMedia, Typography, Box } from "@mui/material";

const ProjectCard = ({ title, image, description, link, technologies }) => {
	const cardContent = (
		<Card
			sx={{
				maxWidth: 420,
				height: 380, // Adjust height to accommodate the technologies list
				margin: 2,
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between",
				backgroundColor: "#383838"
			}}
		>
			<CardContent sx={{ paddingBottom: "0px", flexGrow: 1 }}>
				<Typography
					gutterBottom
					variant="h5"
					component="div"
					align="center"
					color="white"
					sx={{ fontWeight: "bold" }}
				>
					{title}
				</Typography>
			</CardContent>
			<Box sx={{ display: "flex", justifyContent: "center" }}>
				<CardMedia
					component="img"
					sx={{ width: "auto", maxHeight: 200 }}
					image={image}
					alt={title}
				/>
			</Box>
			<CardContent
				sx={{
					flexGrow: 1,
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between"
				}}
			>
				<Box sx={{ flexGrow: 1 }}>
					<Typography
						variant="body2"
						color="text.secondary"
						sx={{ height: "60px", overflow: "hidden" }}
					>
						{description}
					</Typography>
				</Box>
				{technologies && (
					<Box sx={{ marginTop: 2, textAlign: "center" }}>
						<Box
							sx={{
								display: "flex",
								justifyContent: "center",
								flexWrap: "wrap",
								gap: 1
							}}
						>
							{technologies.map((tech, index) => (
								<Typography key={index} variant="body2" color="text.secondary">
									#{tech}
								</Typography>
							))}
						</Box>
					</Box>
				)}
			</CardContent>
		</Card>
	);

	return link ? (
		<a
			href={link}
			target="_blank"
			rel="noopener noreferrer"
			style={{ textDecoration: "none" }}
		>
			{cardContent}
		</a>
	) : (
		cardContent
	);
};

export default ProjectCard;
